export default "__VITE_ASSET__77ab1e59__"